import {RefundableOptions, RefundableProvider, RefundableContent, useRefundableActions} from 'protect-group-dynamic-refundable-react'
import {useEffect} from 'react'

const options: RefundableOptions = {
	currencyCode: 'mxn',
	environment: 'test',
	eventDateFormat: 'DD/MM/YYYY',
	languageCode: 'en',
	vendorCode: 'ven_local_eb87d7b463ac449989296aae85db9788'
};

export default function RefundableLegacy() {
	const { updateQuoteData } = useRefundableActions();

	useEffect(() => {
		updateQuoteData({
			eventTravelDateTime: '13/06/2025',
			numberOfTickets: 1,
			riskType: 'dynamic',
			totalValue: 110
		})
	}, [])

	return (
		<RefundableProvider options={options}>
			<Refundable/>
		</RefundableProvider>
	)
}

function Refundable() {
	return (
		<RefundableContent onProtectionChange={args => console.log(args)}/>
	)
}